import { useMutation } from '@tanstack/react-query';
import { generateReport, previewReport } from '../requests/report.request';
import { ReportBuilderRequest, ReportPreview } from '../types/report.types';
import toast from 'react-hot-toast';
import { AxiosError } from 'axios';

export const useGenerateReportMutation = () => {
  return useMutation<void, AxiosError, ReportBuilderRequest>({
    mutationKey: ['generate-report'],
    mutationFn: generateReport,
    onError: (error) => {
      toast.error(error.message || 'Failed to generate report');
    },
    onSuccess: () => {
      toast.success('Report generated successfully');
    }
  });
};

export const usePreviewReportMutation = () => {
  return useMutation<ReportPreview, AxiosError, ReportBuilderRequest>({
    mutationKey: ['preview-report'],
    mutationFn: previewReport,
    onError: (error) => {
      toast.error(error.message || 'Failed to preview report');
    }
  });
};
